import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import Card from '@johnlewispartnership/wtr-ingredients/ingredients/Card';
import {
  emailInputValidator,
  TextField,
} from '@johnlewispartnership/wtr-ingredients/ingredients/Forms';
import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import urls from 'constants/urls';
import { appendClientIdParam } from 'utils/append-client-id-param';
import styles from './ForgotPassword.scss';

const EMAIL_REQUIRED = 'Please enter your email address';

const Form = ({ linkExpired = false, onSubmit }) => {
  const mainText = linkExpired
    ? 'To request a new link, please enter the email address you use to sign in.'
    : `Enter the email address you use to sign in and we'll send you a link to reset your password.`;
  const submitCtaLabel = linkExpired ? 'Send new link' : 'Send link';

  const [submitDisabled, setSubmitDisabled] = useState(true);

  const {
    errors,
    formState: { isSubmitting },
    handleSubmit,
    register,
  } = useForm();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSubmitDisabled(false);
  }, []);

  return (
    <>
      <Card>
        <div className={styles.text}>
          <Typography styleAs="sectionHeading">Reset your password</Typography>
          <Typography data-test="mainText">{mainText}</Typography>
        </div>
        <form method="POST" noValidate onSubmit={handleSubmit(onSubmit)}>
          <TextField
            errorText={errors?.email?.message}
            id="email"
            label="Email address"
            name="email"
            ref={register({
              required: EMAIL_REQUIRED,
              validate: emailInputValidator,
            })}
            required
            type="email"
          />
          <div className={styles.buttonContainer}>
            <Button
              disabled={submitDisabled}
              id="forgotPasswordSubmit"
              label={submitCtaLabel}
              type="submit"
              waiting={isSubmitting}
              width="full"
            />
          </div>
        </form>
        <TextLink className={styles.returnToSignIn} href={appendClientIdParam(urls.signIn)}>
          Return to sign in
        </TextLink>
      </Card>
      <div className={styles.forgottenAddress}>
        <Typography styleAs="paragraphHeading">Forgotten your email address?</Typography>
        <Typography>
          If you can&apos;t remember the email you use to sign into your account please call us on{' '}
          <a href="tel:0800188884" className={styles.mainTextBold}>
            0800 188 884
          </a>
        </Typography>
      </div>
    </>
  );
};

Form.propTypes = {
  linkExpired: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default Form;
